import PropTypes from 'prop-types'
import React from 'react'

import Image from '../images'

const work = ({ article, articleTimeout, redirectClick, close }) => {

  return (
    <article
      id="project"
      className={`${article === 'project' ? 'active' : ''} ${articleTimeout ? 'timeout' : ''}`}
      style={{ display: 'none' }}
    >
      <h2 className="major">Projects</h2>

      {/* <h3>Libretxt</h3>
      <span className="image main">
        <Image imageName="libretxt.png" alt="libretxt" />
      </span>
      <p>
        Libretxt is a simple SMS server Website this offer a free SMS service, 
        By using this Website users are able to send messages to all netwoks in the Philippines. 
        This Website is fully responsive.
      </p>
      <ul className="icons">
        <li>
            <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
            <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
            <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
            <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
      </ul>

      <h3>Greenery</h3>
      <span className="image main">
        <Image imageName="greenery.png" alt="greenery" />
      </span>
      <p>
        Greenery is a simple Landing page that visitors are able to sigup for subscriptions and have admin dashboard where admin can manage the subscription list.
      </p>
      <ul className="icons">
        <li>
            <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
            <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
            <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
            <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
      </ul>

      <h3>Nigerian Payroll System</h3>
      <span className="image main">
        <Image imageName="nigeria.png" alt="greenery" />
      </span>
      <p>
        Nigerian Payroll System is a simple Web base Payroll System which users are able to create their own payroll tracking for the employees.  
      </p>
      <ul className="icons">
        <li>
            <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
            <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
            <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
            <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
            <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
      </ul> */}

      <h3>Inurance Partner PH</h3>
      <span className="image main">
        <Image imageName="insurance.png" alt="greenery" />
      </span>
      <p><a href="https://insurancepartner.ph">inurancepartner.ph</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Alcova Amadeo</h3>
      <span className="image main">
        <Image imageName="alcova.png" alt="greenery" />
      </span>
      <p><a href="https://alcova.ph">alcova.ph</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>The Dreway</h3>
      <span className="image main">
        <Image imageName="dreway.png" alt="greenery" />
      </span>
      <p><a href="http://thedrewayxo.com/">thedrewayxo.com</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Universal Harvester Insurance Agency</h3>
      <span className="image main">
        <Image imageName="harvester.png" alt="greenery" />
      </span>
      <p><a href="https://universalharvesterinsurance.com/">universalharvesterinsurance.com</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Misa Dining And Listening Bar</h3>
      <span className="image main">
        <Image imageName="misa.png" alt="greenery" />
      </span>
      <p><a href="https://rweb.solutions/misa/public">misa</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Pickmeup</h3>
      <span className="image main">
        <Image imageName="pickmeup.png" alt="greenery" />
      </span>
      <p><a href="#">pickmeup</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
      </ul>

      <h3>Paper View</h3>
      <span className="image main">
        <Image imageName="ppv.png" alt="greenery" />
      </span>
      <p><a href="#">ppv</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
      </ul>

      <h3>Pay per View</h3>
      <span className="image main">
        <Image imageName="ppv.png" alt="greenery" />
      </span>
      <p><a href="#">ppv</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
      </ul>

      <h3>Quanta Philippines</h3>
      <span className="image main">
        <Image imageName="quanta.png" alt="greenery" />
      </span>
      <p><a href="https://rweb.solutions/quantaservices/public">quanta</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Reps Philippines</h3>
      <span className="image main">
        <Image imageName="reps.png" alt="greenery" />
      </span>
      <p><a href="http://repsphilippines.com/">repsphilippines.com</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Serbisking</h3>
      <span className="image main">
        <Image imageName="serbisking.png" alt="greenery" />
      </span>
      <p><a href="http://serbisking.ph/">serbisking.ph</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
        <li>
          <span title="PHP" className="icon fab fa-php php-text"></span>
        </li>
        <li>
          <span title="Laravel" className="icon fab fa-laravel bootstrap-text"></span>
        </li>
      </ul>

      <h3>Viyzaar</h3>
      <span className="image main">
        <Image imageName="viyzaar.png" alt="greenery" />
      </span>
      <p><a href="https://rweb.solutions/viyzaar/public">viyzaar</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
      </ul>

      <h3>Rweb One Pager</h3>
      <span className="image main">
        <Image imageName="rweb_one_page.png" alt="greenery" />
      </span>
      <p><a href="https://rweb.solutions/1">Rweb-one</a></p>
      <ul className="icons">
        <li>
          <span title="HTML" className="icon fab fa-html5 html5-text"></span>
        </li>
        <li>
          <span title="CSS" className="icon fab fa-css3 css3-text"></span>
        </li>
        <li>
          <span title="Javascript" className="icon fab fa-js js-text"></span>
        </li>
        <li>
          <span title="Bootstrap" className="icon fab fa-bootstrap bootstrap-text"></span>
        </li>
      </ul>

      <div className="pagination">
        <div className="pagination-left">
          <button onClick={() => { redirectClick('skills'); }}><span className="icon fas fa-arrow-left"></span> Skills</button>
        </div>
        <div className="pagination-right">
          <button onClick={() => { redirectClick('contact'); }}>Contact <span className="icon fas fa-arrow-right"></span> </button>
        </div>
      </div>

      {close}
    </article>
  );
}

work.propTypes = {
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  close: PropTypes.object
}

export default work
